import { render } from "./UserNewArticles.vue?vue&type=template&id=d3e60ea6&scoped=true&ts=true&lang=pug"
import script from "./UserNewArticles.vue?vue&type=script&lang=ts"
export * from "./UserNewArticles.vue?vue&type=script&lang=ts"

import "./UserNewArticles.vue?vue&type=style&index=0&id=d3e60ea6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3e60ea6"]])

export default __exports__